import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    versions: Array,
    blah: String
  }

  connect() {
  }

  load(event) {
    const selectedId = event.target.value
    if (!selectedId) return

    const version = this.versionsValue.find(v => v.id === selectedId)
    if (!version) return
    console.log(version)

    // Find the markdown editor and use its Stimulus controller
    const editorWrapper = document.querySelector('[data-controller="markdown-editor"]')
    if (editorWrapper && editorWrapper.tiptapEditor) {
      // Use the setContent method via the application controller
      const markdownController = this.application.getControllerForElementAndIdentifier(
        editorWrapper,
        'markdown-editor'
      )
      if (markdownController) {
        markdownController.setContent(version.prompt)
        return
      }
    }
    
    // Fallback to regular textarea
    const textarea = document.getElementById('agent_system_instructions')
    if (textarea) {
      textarea.value = version.prompt
    }
  }
}
